import http from "plugins/axios";

const prefix = "/ta/admin/tenant/fee-rate-whitelist";

// 仅模拟分页列表；详情、新建、启停和删除仍请求真实接口。
// 列表接口联调时改为 false 即可恢复真实数据。
export const USE_MOCK_PAGE = false;

const mockList = [
  {
    id: "193000000000000001",
    name: "VIP用户现货费率",
    targetType: 1,
    targetTypeName: "指定用户",
    targetIds: ["100001", "100002"],
    businessType: 1,
    businessTypes: [1],
    symbolScope: 2,
    symbolScopeName: "指定交易对",
    symbols: [
      { businessType: 1, symbolId: "101" },
      { businessType: 1, symbolId: "102" },
    ],
    configMode: 1,
    configModeName: "费率系数",
    makerCoefficientPercent: 80,
    takerCoefficientPercent: 90.5,
    makerFeeRatePercent: null,
    takerFeeRatePercent: null,
    status: 1,
    statusName: "生效中",
    createdBy: "admin",
    createdTime: "2026-08-10T10:20:30",
    updatedBy: "admin",
    updatedTime: "2026-08-12T09:30:00",
    version: 0,
  },
  {
    id: "193000000000000002",
    name: "总代全业务固定费率",
    targetType: 2,
    targetTypeName: "指定合伙人",
    targetIds: ["200001"],
    businessType: 3,
    businessTypes: [1, 2],
    symbolScope: 1,
    symbolScopeName: "全部交易对",
    symbols: [],
    configMode: 2,
    configModeName: "固定手续费率",
    makerCoefficientPercent: null,
    takerCoefficientPercent: null,
    makerFeeRatePercent: 0.006,
    takerFeeRatePercent: 0.0125,
    status: 2,
    statusName: "已停用",
    createdBy: "operator01",
    createdTime: "2026-08-08T14:00:00",
    updatedBy: "reviewer",
    updatedTime: "2026-08-11T18:12:45",
    version: 2,
  },
  {
    id: "193000000000000003",
    name: "合约做市用户系数",
    targetType: 1,
    targetTypeName: "指定用户",
    targetIds: ["100086"],
    businessType: 2,
    businessTypes: [2],
    symbolScope: 2,
    symbolScopeName: "指定交易对",
    symbols: [{ businessType: 2, symbolId: "301" }],
    configMode: 1,
    configModeName: "费率系数",
    makerCoefficientPercent: 0,
    takerCoefficientPercent: 75.25,
    makerFeeRatePercent: null,
    takerFeeRatePercent: null,
    status: 1,
    statusName: "生效中",
    createdBy: "risk_admin",
    createdTime: "2026-08-05T09:15:10",
    updatedBy: "risk_admin",
    updatedTime: "2026-08-09T16:40:20",
    version: 1,
  },
  {
    id: "193000000000000004",
    name: "现货零手续费测试组",
    targetType: 1,
    targetTypeName: "指定用户",
    targetIds: ["100101", "100102", "100103"],
    businessType: 1,
    businessTypes: [1],
    symbolScope: 1,
    symbolScopeName: "全部交易对",
    symbols: [],
    configMode: 2,
    configModeName: "固定手续费率",
    makerCoefficientPercent: null,
    takerCoefficientPercent: null,
    makerFeeRatePercent: 0,
    takerFeeRatePercent: 0,
    status: 2,
    statusName: "已停用",
    createdBy: "admin",
    createdTime: "2026-08-01T11:11:11",
    updatedBy: "admin",
    updatedTime: "2026-08-07T12:00:00",
    version: 3,
  },
];

function getMockPage(params = {}) {
  const page = Number(params.page) || 1;
  const size = Number(params.size) || 20;
  const filteredList = mockList.filter((item) => {
    const matchesName = !params.name || item.name.indexOf(params.name) > -1;
    const matchesBusiness =
      !params.businessType || item.businessTypes.indexOf(params.businessType) > -1;
    const matchesTarget = !params.targetType || item.targetType === params.targetType;
    const matchesStatus = !params.status || item.status === params.status;
    const matchesCreator = !params.createdBy || item.createdBy === params.createdBy;

    return (
      matchesName &&
      matchesBusiness &&
      matchesTarget &&
      matchesStatus &&
      matchesCreator
    );
  });
  const start = (page - 1) * size;

  return Promise.resolve({
    code: 0,
    msg: "success",
    data: {
      totalCount: filteredList.length,
      list: filteredList.slice(start, start + size),
    },
  });
}

export default {
  page(data) {
    if (USE_MOCK_PAGE) {
      return getMockPage(data);
    }
    return http.get({ url: `${prefix}/page`, data });
  },
  detail(id) {
    return http.get({ url: `${prefix}/detail`, data: { id } });
  },
  create(data) {
    return http.post({ url: `${prefix}/create`, data });
  },
  enable(data) {
    return http.post({ url: `${prefix}/enable`, data });
  },
  disable(data) {
    return http.post({ url: `${prefix}/disable`, data });
  },
  remove(data) {
    return http.post({ url: `${prefix}/delete`, data });
  },
  symbols(type) {
    return http.get({
      url: "/ta/admin/tenant/symbol/getSymbolList",
      data: { type: type === 1 ? "SPOT" : "CONTRACT" },
    });
  },
};
